<template>
    <div class="wrap reveal-bottom">
        <router-link class="img" :to="'/NewDetail/' + id">
            <img class="img-bg" :src="img" alt="img" />
            <div class="img-mark">
                <img
                    class="next"
                    :src="require('@/assets/img_svg/next1.svg')"
                    alt="svg"
                />
            </div>
        </router-link>
        <div class="right">
            <h3 class="title" v-ellipsis>{{ title }}</h3>
            <div class="text" v-ellipsis>
                {{ text }}
            </div>
            <div class="time">{{ time }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "New",
    props: {
        img: String,
        title: String,
        text: String,
        time: String,
        id: String | Number,
    },
};
</script>
<style scoped>
.wrap {
    width: 1200px;
    height: 200px;
    display: flex;
    margin-top: 100px;
    padding: 0 10px;
    box-sizing: border-box;
}
.img {
    display: block;
    width: 373px;
    height: 200px;
    position: relative;
}
.img-bg {
    width: 100%;
    height: 100%;
}
.img-mark {
    position: absolute;
    width: 373px;
    height: 200px;
    top: 0;
    left: 0;
    background-color: rgba(0, 163, 209, 0.9);
    opacity: 0;
    transition: opacity 1.5s ease;
    cursor: pointer;
}
.next {
    display: block;
    width: 35px;
    height: 35px;
    margin: 83px auto 0;
    cursor: pointer;
}
.img-mark:hover {
    opacity: 0.9;
}
.right {
    margin-left: 38px;
    flex: 1;
}
.title {
    font-size: 22px;
    color: #000000;
    font-weight: bold;
    line-height: 33px;
    height: 33px;
}
.text {
    width: 100%;
    height: 124px;
    margin-top: 13px;
    margin-bottom: 14px;
    font-size: 18px;
    color: #000000;
    line-height: 32px;
}
.time {
    font-size: 14;
    color: rgba(0, 0, 0, 0.5);
    line-height: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/New.vue